module.exports = __webpack_public_path__ + "img/web-p2-c3.e21e0f47.svg";